import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import data from "@/routes/innovation-days-demo/data/little_prince_metadata.json" with { type: "json" };
import type { ManuscriptMetadata } from "@/routes/innovation-days-demo/types";
import { OverviewCollapsibles } from "@/routes/innovation-days-demo/components/overview/OverviewCollapsibles";

function BookPage() {
  const manuscript = React.useMemo(
    () => data as unknown as ManuscriptMetadata,
    [],
  );

  return <OverviewCollapsibles manuscript={manuscript} />;
}

export const Route = createFileRoute("/innovation-days-demo/_layout/")({
  component: BookPage,
});
